import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ParticipantListPickerQueryVariables = {
  filter?: Types.Maybe<Types.ProvingFilterType>
};


export type ParticipantListPickerQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'title' | 'dateFrom' | 'dateTo' | 'department' | 'status'>
    & { provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name'>
    )>, participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'dateFrom' | 'dateTo' | 'percentage'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, 'external' | 'extension' | '_id' | 'type' | 'firstName' | 'lastName'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id' | 'type' | 'firstName' | 'lastName'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'isUnknown' | 'personType' | 'department' | 'supplier' | 'employee' | 'firstName' | 'surName'>
      )> }
    )>> }
  )> }
);

export const ParticipantListPickerDocument = gql`
    query ParticipantListPicker($filter: ProvingFilterType) {
  provings(filter: $filter) {
    _id
    id
    title
    provingGround {
      _id
      title
    }
    dateFrom
    dateTo
    responsible {
      _id
      name
    }
    department
    status
    participants {
      _id
      dateFrom
      dateTo
      percentage
      person {
        _id
        type
        firstName
        lastName
        ... on User {
          external
          extension
        }
      }
      unknownPerson {
        isUnknown
        personType
        department
        supplier
        employee
        firstName
        surName
      }
    }
  }
}
    `;

    export function useParticipantListPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ParticipantListPickerQuery, ParticipantListPickerQueryVariables>) {
      return ApolloReactHooks.useQuery<ParticipantListPickerQuery, ParticipantListPickerQueryVariables>(ParticipantListPickerDocument, baseOptions);
    };
      export function useParticipantListPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ParticipantListPickerQuery, ParticipantListPickerQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ParticipantListPickerQuery, ParticipantListPickerQueryVariables>(ParticipantListPickerDocument, baseOptions);
      };
      
export type ParticipantListPickerQueryHookResult = ReturnType<typeof useParticipantListPickerQuery>;
export type ParticipantListPickerQueryResult = ApolloReactCommon.QueryResult<ParticipantListPickerQuery, ParticipantListPickerQueryVariables>;